import { useCallback, useEffect, useState } from "react";
import { Button, Input, Popup } from "semantic-ui-react";
import { toast } from "../..";
import { saveInactivitySettings, getInactivitySettings } from "../../services/settingsService";

export const UserSettings = () => {
    const [maxInactivityMinutes, setMaxInactivityMinutes] = useState<number>();
    const [maxInactivityChanged, setMaxInactivityChanged] = useState<boolean>(false);
    const [maxInactivityDays, setMaxInactivityDays] = useState<number>();
    const [maxInactivityDaysChanged, setMaxInactivityDaysChanged] = useState<boolean>(false);
    const [inactivityError, setInactivityError] = useState<string>("");

    const fetchSettings = useCallback(async () => {
        try {
            const data = await getInactivitySettings();
            setMaxInactivityMinutes(data.inactivityTimeout);
            setMaxInactivityDays(data.inactivityDaysUntilDisable);
        } catch {
            toast("Unable to fetch settings", false, 3000);
        }
    }, [setMaxInactivityMinutes]);

    const handleSaveInactivityChanges = useCallback(async () => {
        try {
            if (maxInactivityMinutes && maxInactivityDays) {
                await saveInactivitySettings({
                    inactivityTimeout: maxInactivityMinutes,
                    inactivityDaysUntilDisable: maxInactivityDays,
                });
                setMaxInactivityChanged(false);
                setMaxInactivityDaysChanged(false);
                toast("Settings updated", true, 3000);
            }
        } catch (err) {
            toast(err as string, false, 3000);
        }
    }, [maxInactivityMinutes, maxInactivityDays]);

    useEffect(() => {
        // Validate max inactivity.
        if (!maxInactivityMinutes || maxInactivityMinutes > 20 || maxInactivityMinutes < 5) {
            setInactivityError("Max inactivity must be between 5 and 20 minutes");
        } else {
            setInactivityError("");
        }
    }, [maxInactivityMinutes]);

    useEffect(() => {
        fetchSettings();
    }, [fetchSettings]);

    return (
        <div id="user-settings-container" className="user-settings-container">
            <div id="user-settings-content" className="user-settings-content">
                <div id="user-settings-row" className="user-settings-row">
                    <div id="user-settings-input-a" className="user-settings-input">
                        <label id="label-userSettings-maxMinutes">Max minutes of inactivity</label>
                        <Input
                            id="input-userSettings-a"
                            type="number"
                            min={5}
                            max={20}
                            step={1}
                            value={maxInactivityMinutes}
                            onChange={e => {
                                setMaxInactivityMinutes(parseFloat(e.target.value));
                                setMaxInactivityChanged(true);
                            }}
                        />
                    </div>
                    <div id="user-settings-input-b" className="user-settings-input">
                        <label id="label-userSettings-maxDays">Max days without login</label>
                        <Input
                            id="input-userSettings-b"
                            type="number"
                            value={maxInactivityDays}
                            onChange={e => {
                                setMaxInactivityDays(parseFloat(e.target.value));
                                setMaxInactivityDaysChanged(true);
                            }}
                        />
                    </div>
                    <div id="user-settings-button-div-a" className="user-settings-button">
                        <Popup
                            id="popup-userSettings"
                            disabled={inactivityError === ""}
                            content={inactivityError}
                            trigger={
                                <span id="span-userSettings-a">
                                    <Button
                                        id="button-userSettings"
                                        className="tsc-button"
                                        disabled={
                                            inactivityError !== "" ||
                                            (!maxInactivityChanged && !maxInactivityDaysChanged)
                                        }
                                        icon="save"
                                        primary
                                        onClick={handleSaveInactivityChanges}
                                    >
                                        Save
                                    </Button>
                                </span>
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
